import { createContext } from 'react';

const logsContext = createContext();

export default logsContext;
